var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n.icon-menu-st1{fill:none;stroke:#D82126;stroke-width:7;stroke-linecap:round;stroke-miterlimit:10;\n"),React.createElement("g",{"id":"hamburger","key":1},[React.createElement("line",{"id":"bottom","className":"icon-menu-st1","x1":"3.6","y1":"39.9","x2":"48.4","y2":"39.9","key":0}),React.createElement("line",{"id":"middle","className":"icon-menu-st1","x1":"3.6","y1":"21.9","x2":"48.4","y2":"21.9","key":1}),React.createElement("line",{"id":"top","className":"icon-menu-st1","x1":"3.6","y1":"3.9","x2":"48.4","y2":"3.9","key":2})])]);
}

IconHamburger.defaultProps = {"className":"btn-open","width":"52","height":"43.6","viewBox":"0 0 52 43.6"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
